import React, { useEffect, useState } from "react";
import ImageLinks from "../../assets/Images/ImagesLink";
import { useNavigate } from "react-router-dom";

const OrderSuccessModal = ({ close }) => {
  const navigate = useNavigate();
  const [count_down, set_count_down] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      set_count_down((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    if (count_down === 0) {
      close();
      //   navigate("/order-track-list");
    }
  }, [count_down]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 px-6 ">
      <div className="bg-white rounded-xl shadow-3xl max-w-md overflow-x-hidden">
        <div className="relative flex justify-center  ">
          <img src={ImageLinks.ellips_payment_failed} className="w-[100%]" />
          <div className="w-12 h-12 flex items-center justify-center rounded-full absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 ">
            <img src={ImageLinks.icon_cross_red} />
          </div>
        </div>
        <div className="p-6 text-center mt-10 flex gap-2 flex-col">
          <p className="font-custom text-xl font-bold text-dark_black">
            Payment Failed
          </p>
          <p className="font-custom text-sm font-medium text-dark_black ">
            Any amount deducted would reflect in wallet within 24 hours.
          </p>
        </div>
        <div className="text-center mt-10 mb-4">
          <p className="font-custom text-xs font-medium text-dark_gray">
            Redirecting to homepage in {count_down}...
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessModal;
